document.addEventListener('DOMContentLoaded', () => {
  const $ = (s,c=document) => c.querySelector(s);
  const $$ = (s,c=document) => Array.from(c.querySelectorAll(s));

  $('[data-nav-toggle]')?.addEventListener('click',()=>{
    $('[data-mobile-nav]')?.toggleAttribute('hidden');
  });

  const drawer = $('[data-cart-drawer]');
  const shade = $('[data-cart-shade]');
  const body = $('[data-cart-body]');
  const total = $('[data-cart-total]');
  const counts = $$('[data-cart-count]');

  const money = cents => new Intl.NumberFormat('en-US',{
    style:'currency',
    currency: document.body.dataset.currency || 'USD'
  }).format((cents||0)/100);

  const bonusConfig = () => document.querySelector('[data-sovelle-bonus-config]');

  function isAutoBonusLine(item){
    return !!(
      item &&
      item.properties &&
      String(item.properties._sovelle_bonus || '') === '4 Pillow Gift'
    );
  }

  async function syncEbookBonus(cart){
    const cfg = bonusConfig();
    if(!cfg) return false;

    const ebookVariantId = Number(cfg.dataset.ebookVariantId || 0);
    if(!ebookVariantId) return false;

    const q = qualifyingPillowQty(cart,cfg);
    const autoBonusLines = (cart.items || []).filter(item =>
      Number(item.variant_id || item.id || 0) === ebookVariantId && isAutoBonusLine(item)
    );

    if(q >= 4 && autoBonusLines.length === 0){
      const r = await fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({
          items:[{
            id:ebookVariantId,
            quantity:1,
            properties:{
              "_sovelle_bonus":"4 Pillow Gift"
            }
          }]
        })
      });
      return r.ok;
    }

    if(q < 4 && autoBonusLines.length){
      let changed = false;
      for(const item of autoBonusLines){
        const r = await fetch('/cart/change.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:item.key,quantity:0})
        });
        if(r.ok) changed = true;
      }
      return changed;
    }

    return false;
  }

  function qualifyingPillowQty(cart,box){
    const handle=(box?.dataset.qualifyingHandle || '').trim().toLowerCase();
    const matched=(cart.items || []).filter(item=>{
      const itemHandle=String(item.handle || '').toLowerCase();
      const title=String(item.product_title || '').toLowerCase();
      if(handle) return itemHandle===handle;
      return title.includes('cloud pillow');
    });
    return matched.reduce((sum,item)=>sum+Number(item.quantity||0),0);
  }

  function updatePillowCartOffer(box,cart){
    if(!box) return;
    const q=qualifyingPillowQty(cart,box);
    const ebook=box.dataset.ebookName || 'Hotel Bed at Home Guide';
    const copy=box.querySelector('[data-pillow-cart-copy]');
    const badge=box.querySelector('[data-pillow-cart-badge]');
    const bar=box.querySelector('[data-pillow-cart-bar]');
    let message='', badgeText='';
    if(q < 2){
      const left=2-q;
      message=`Add ${left} more Cloud Pillow${left===1?'':'s'} to unlock free shipping.`;
      badgeText=`${q} / 2`;
    }else if(q < 4){
      const left=4-q;
      message=`Free shipping unlocked — add ${left} more Cloud Pillow${left===1?'':'s'} to unlock the free ${ebook}.`;
      badgeText='Free shipping unlocked';
    }else{
      message=`Free shipping + free ${ebook} unlocked.`;
      badgeText='Best offer unlocked';
    }
    if(copy) copy.textContent=message;
    if(badge) badge.textContent=badgeText;
    if(bar) bar.style.width=`${Math.min(100,(q/4)*100)}%`;
  }

  async function getCart(){
    const r = await fetch('/cart.js',{headers:{Accept:'application/json'}});
    return await r.json();
  }

  async function refreshCart(){
    let cart = await getCart();

    const bonusChanged = await syncEbookBonus(cart);
    if(bonusChanged){
      cart = await getCart();
    }

    counts.forEach(el=>el.textContent=cart.item_count);
    if(total) total.textContent = money(cart.total_price);

    const hasAutoBonus = (cart.items || []).some(isAutoBonusLine);
    document.querySelectorAll('[data-bonus-note]').forEach(el=>{
      el.hidden = !hasAutoBonus;
    });

    if(!body) return;

    if(!cart.items.length){
      body.innerHTML = `
        <div class="drawer-empty">
          <p>Your bed is waiting.</p>
          <a class="btn" href="/collections/all">Shop Sovelle</a>
        </div>`;
      return;
    }

    body.innerHTML = cart.items.map(item=>{
      const autoBonus = isAutoBonusLine(item);
      return `
      <div class="drawer-line">
        <a href="${item.url}" class="drawer-line__image">
          ${item.image ? `<img src="${item.image}" alt="">` : ''}
        </a>
        <div class="drawer-line__copy">
          <a href="${item.url}" class="drawer-line__title">${item.product_title}</a>
          <small>${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</small>
          ${autoBonus ? '<span class="drawer-line__bonus">4-pillow bonus</span>' : ''}
          <div class="drawer-line__foot">
            <span>Qty ${item.quantity}</span>
            <strong>${money(item.final_line_price)}</strong>
          </div>
        </div>
      </div>`;
    }).join('');
  }

  function openCart(){
    if(!drawer) return;
    drawer.removeAttribute('hidden');
    shade?.removeAttribute('hidden');
    document.body.classList.add('drawer-open');
    requestAnimationFrame(()=>drawer.classList.add('is-open'));
  }

  function closeCart(){
    drawer?.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    setTimeout(()=>{
      drawer?.setAttribute('hidden','');
      shade?.setAttribute('hidden','');
    },220);
  }

  $$('[data-open-cart]').forEach(el=>el.addEventListener('click',async e=>{
    e.preventDefault();
    await refreshCart();
    openCart();
  }));

  $('[data-close-cart]')?.addEventListener('click',closeCart);
  shade?.addEventListener('click',closeCart);

  window.SovelleCart = {refresh:refreshCart,open:openCart,close:closeCart};
  refreshCart().catch(()=>{});
});
